import React, { useEffect, useState } from 'react';
import { Container, Grid, Paper, Typography, Box, CircularProgress } from '@mui/material';

const SimpleDashboard: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState<any>(null);

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  const fetchDashboardStats = async () => {
    try {
      const response = await fetch('http://localhost:3000/api/v1/dashboard/stats');
      const data = await response.json();
      if (data.success) {
        setStats(data.data);
      }
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        IAM-ACV Emergency Response Dashboard
      </Typography>
      
      <Grid container spacing={3}>
        {/* Emergency Stats */}
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 140 }}>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
              Active Emergencies
            </Typography>
            <Typography component="p" variant="h4">
              {stats?.activeEmergencies || 0}
            </Typography>
            <Typography color="text.secondary" sx={{ flex: 1 }}>
              Currently active
            </Typography>
          </Paper>
        </Grid>
        
        {/* Users */}
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 140 }}>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
              Total Users
            </Typography>
            <Typography component="p" variant="h4">
              {stats?.totalUsers?.toLocaleString() || 0}
            </Typography>
            <Typography color="text.secondary" sx={{ flex: 1 }}>
              Registered users
            </Typography>
          </Paper>
        </Grid>
        
        {/* Response Time */}
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 140 }}>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
              Avg Response Time
            </Typography>
            <Typography component="p" variant="h4">
              {stats?.avgResponseTime || 0}
            </Typography>
            <Typography color="text.secondary" sx={{ flex: 1 }}>
              minutes
            </Typography>
          </Paper>
        </Grid>
        
        {/* Health Records */}
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 140 }}>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
              Health Records
            </Typography>
            <Typography component="p" variant="h4">
              {stats?.healthRecords || 0}
            </Typography>
            <Typography color="text.secondary" sx={{ flex: 1 }}>
              Total records
            </Typography>
          </Paper>
        </Grid>
        
        {/* Recent Activity */}
        <Grid item xs={12}>
          <Paper sx={{ p: 2 }}>
            <Typography component="h2" variant="h6" color="primary" gutterBottom>
              Recent Emergency Alerts
            </Typography>
            <Box sx={{ mt: 2 }}>
              {stats?.recentEmergencies?.map((emergency: any) => (
                <Typography key={emergency.id}>
                  • {emergency.type} emergency in {emergency.location} - {emergency.time}
                </Typography>
              )) || <Typography>No recent emergencies</Typography>}
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default SimpleDashboard;